import { Injectable } from '@nestjs/common';
import { EntityRepository, Repository } from 'typeorm';
// import { LogActions, LoggerInstantiation } from '@cmg/backend-utils';
// import { mdmConfigs } from '../../../../config';
import { FreebieEntity } from '../entity/freebie.entity';

@Injectable()
@EntityRepository(FreebieEntity)
export class FreebieRepo extends Repository<FreebieEntity> {

    constructor() {
        super();
    }
}
